var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('van-button',{staticClass:"btn-is_coll",class:_vm.is_coll?'is_coll':'',attrs:{"loading":_vm.load},on:{"click":_vm.save},nativeOn:{"mouseover":function($event){return _vm.hovering('over')},"mouseout":function($event){return _vm.hovering('out')}}},[_vm._v(_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }